import { EMPTY_STRING } from '../../../constants/common'
import {
  FILTER_TEMPLATE_NAME_FIELD,
  FILTER_TEMPLATE_NAME_FIELD_PUBLIC,
} from '../Filter.constants'

export const FILTER_SAVE_MODAL_INITIAL_VALUES = {
  [FILTER_TEMPLATE_NAME_FIELD]: EMPTY_STRING,
  [FILTER_TEMPLATE_NAME_FIELD_PUBLIC]: false,
}
